"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var react_2 = require("@fluentui/react");
var react_redux_1 = require("react-redux");
var reducers_1 = require("../../reducers");
var CustomLabel_1 = require("./CustomLabel");
require("./Forms.scss");
require("./CustomDropdown.scss");
var connector = react_redux_1.connect(reducers_1.ComponentEtaMapStateToProps);
var CustomDropdown = function (props) {
    var className = props.className, readOnly = props.readOnly, currentLang = props.currentLang, containerClassName = props.containerClassName, required = props.required, toolTip = props.toolTip, toolTipLink = props.toolTipLink, toolTipLinkOnClick = props.toolTipLinkOnClick, callOutWidth = props.callOutWidth;
    var useClassName = clsx_1.default(className, readOnly ? 'eta-cDropDownReadOnly' : '', currentLang.isRtl ? 'rtlFlag' : 'ltrFlag');
    var label = props.label;
    var validationFunc = props.validationFunc, onValidationChange = props.onValidationChange, errorMessageFromProps = props.errorMessage, selectedKey = props.selectedKey, id = props.id, onRenderContainer = props.onRenderContainer;
    var fieldId = react_1.useState(id !== null && id !== void 0 ? id : react_2.getId('dd_'))[0];
    var _a = react_1.useState(), errorMessage = _a[0], setErrorMessage = _a[1];
    var _b = react_1.useState(undefined), isValid = _b[0], setIsValid = _b[1];
    var onChangeKey = react_1.useCallback(function (key) {
        var newIsValid = true;
        var previousError = errorMessage;
        if (errorMessageFromProps) {
            if (previousError !== errorMessageFromProps) {
                setErrorMessage(errorMessageFromProps);
            }
            //   newIsValid = false;
        }
        else if (validationFunc) {
            var error = validationFunc(key);
            if (previousError !== error) {
                setErrorMessage(error);
            }
            if (error) {
                newIsValid = false;
            }
        }
        if (newIsValid !== isValid) {
            setIsValid(newIsValid);
            if (newIsValid) {
                if (previousError && !errorMessageFromProps) {
                    setErrorMessage(undefined);
                }
            }
            if (onValidationChange) {
                onValidationChange(newIsValid);
            }
        }
    }, [
        errorMessageFromProps,
        errorMessage,
        isValid,
        onValidationChange,
        validationFunc,
    ]);
    react_1.useEffect(function () {
        if (onValidationChange) {
            if (validationFunc) {
                var error = validationFunc(selectedKey);
                onValidationChange(error === undefined);
            }
            else {
                onValidationChange(true);
            }
        }
    }, [selectedKey, onValidationChange, validationFunc]);
    return (react_1.default.createElement("div", { className: clsx_1.default('eta-vertialFlexDiv', containerClassName) },
        label && (react_1.default.createElement(CustomLabel_1.Label, { required: required, toolTip: toolTip, toolTipLink: toolTipLink, toolTipLinkOnClick: toolTipLinkOnClick }, label)),
        react_1.default.createElement(react_2.Dropdown, __assign({}, props, { id: fieldId, calloutProps: { className: callOutWidth !== 'Fixed' ? 'applyContentFit' : '' }, className: useClassName, errorMessage: readOnly ? undefined : errorMessageFromProps !== null && errorMessageFromProps !== void 0 ? errorMessageFromProps : errorMessage, onRenderContainer: function (p, df) {
                if (callOutWidth !== 'Fixed') {
                    var dd = document.getElementById(fieldId);
                    document.body.style.setProperty('--currentEtaDropDownMinSize', (dd === null || dd === void 0 ? void 0 : dd.clientWidth.toString()) + "px");
                }
                if (onRenderContainer) {
                    return (onRenderContainer(p, df));
                }
                if (df) {
                    return (df(p));
                }
                return (null);
            }, required: undefined, label: undefined, onChange: function (e, key) {
                onChangeKey(key === null || key === void 0 ? void 0 : key.key);
                if (props.onChange) {
                    props.onChange(e, key);
                }
            } }))));
};
exports.default = connector(CustomDropdown);
//# sourceMappingURL=CustomDropdown.js.map